import React, { useEffect, useState } from "react";
import { Badge, Box, Tab, Tabs } from "@mui/material";
import "./index.scss";
import InvoiceDataList from "./invoice-data-list";
import { useSearchParams } from "react-router-dom";
import InvoiceApprovalList from "./invoice-approval-list";
import { checkUserRight } from "../../utils/utils";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const InvoicesData = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const openTabIndex = searchParams.get("subIndex");
  const mainTabIndex = searchParams.get("index");
  const [value, setValue] = useState(+openTabIndex || 0);
  const [noOfPendingPayment, setNoOfPendingPayment] = useState(0);
  const [noOfReconsiderPayment, setNoOfReconsiderPayment] = useState(0);
  const loadPendingData = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "invoice_approval",
        invoiceType: "advance_invoice",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingPayment(response?.length || 0);
        }
      })
      .catch((err) => {});
  };
  const getReconsiderData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.INVOICE_DATA}`,
      null,
      {
        invoiceType: "advance_invoice",
        status: "reconsider",
      }
    )
      .then((response) => {
        if (!response.message) {
          setNoOfReconsiderPayment(response?.results?.length || 0);
        }
      })
      .catch((err) => {});
  };
  const handleChange = (event, newValue) => {
    setSearchParams({
      index: mainTabIndex || 0,
      subIndex: newValue,
    });
    setValue(newValue);
  };
  useEffect(() => {
    const openTabIndex = searchParams.get("subIndex");
    if (
      +openTabIndex === 4 &&
      !checkUserRight("paymentDetails.approveReject")
    ) {
      setValue(5);
    }
  }, []);
  useEffect(() => {
    loadPendingData();
    getReconsiderData();
  }, []);
  return (
    <div className="finance-v2-rm-pt finance-v2-budget-list">
      <div className="tabs-section">
        <Box>
          <Tabs
            variant="scrollable"
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: "1px solid #DDE2EC",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": {
                color: "#5B6E8A",
                minWidth: "unset",
                borderRadius: "20px",
                margin: "0 2px",
                textTransform: "none",
                "& .MuiBadge-root": {
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                },
                "& .MuiBadge-badge": {
                  position: "relative",
                  transform: "none",
                  top: "auto",
                  right: "auto",
                  background: "transparent",
                  color: "#007A42",
                  minWidth: "unset",
                  height: "auto",
                  padding: 0,
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  lineHeight: 1,
                  borderRadius: 0,
                  boxShadow: "none",
                  "&.MuiBadge-invisible": { display: "none" },
                },
              },
              "& .Mui-selected": {
                color: "#005F35 !important",
                background: "#EAF4EE",
                "& .MuiBadge-badge": {
                  background: "#005F35",
                  color: "#fff",
                  minWidth: "16px",
                  height: "16px",
                  padding: "0 3px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  borderRadius: "50%",
                },
              },
            }}
            TabIndicatorProps={{ sx: { display: "none" } }}
          >
            <Tab label="Open Adv. Payment Details" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab label="Approved  Adv. Payment Details" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab
              label={
                <Badge badgeContent={noOfReconsiderPayment} color="primary">
                  Reconsidered Adv. Payment Details
                </Badge>
              }
              sx={{ paddingX: 3,fontSize: "0.875rem !important", textTransform: "uppercase !important"}}
            />
            {/* <Tab label="My Reconsidered Advance Payment Details" /> */}
            <Tab label="Rejected  Adv. Payment Details" sx={{ paddingX: 3,fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab
              label={
                <Badge badgeContent={noOfPendingPayment} color="primary">
                  Pending actions
                </Badge>
              }
              sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
            />
            {/* <Tab label="My Pending actions" /> */}
            <Tab label="All Adv. Payment" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
          </Tabs>
        </Box>
      </div>
      <TabPanel value={value} index={0}>
        <InvoiceDataList status="approval_in_progress" />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <InvoiceDataList status="approved" />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <InvoiceDataList status="reconsider" />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <InvoiceDataList status="rejected" />
      </TabPanel>
      <TabPanel value={value} index={4}>
        {checkUserRight("advancePayment.approveReject") ? (
          <InvoiceApprovalList
            approvalType="invoice_approval"
            usedIn="INVOICE_DATA"
            status="approval_in_progress"
            invoiceType="advance_invoice"
          />
        ) : (
          "Not authorized to take action on Advance Payment Details"
        )}
      </TabPanel>
      <TabPanel value={value} index={5}>
        <InvoiceDataList status="all" />
      </TabPanel>
    </div>
  );
};

export default InvoicesData;
